import { AesDecrypt, AesEncrypt, keyPromise } from '../../../../../Service/crypto';
import webservice from '../../../../../Service/webservice';
import api from '../../../../../api';
import { FormDocument } from './types';
import axios from 'axios';

export interface SaveDraftArgs {
  templateId: string | null;
  layoutSchema: FormDocument;
  name: string;
  clientId: string | null;
  clientName: string | null;
  templateCategory?: string;
}

export async function saveDraft(args: SaveDraftArgs): Promise<{ templateId: string }> {
  const key = await keyPromise;
  const username = localStorage.UserName;
  const userId = localStorage.id;
  const EncParams = await AesEncrypt(key, {
    templateId: args.templateId,
    layoutSchema: args.layoutSchema,
    name: args.name,
    clientId: args.clientId,
    clientName: args.clientName,
    templateCategory: args.templateCategory || '',
    username,
    userId,
  });
  const response = await api.fetch('api/FormDesigner/save_draft', {
    method: 'POST',
    body: JSON.stringify({ EncParams }),
  }).then((r) => r.json());
  return AesDecrypt(key, response);
}

export interface GetLayoutResult {
  templateId: string;
  name: string;
  layoutSchema: FormDocument | null;
  clientId: string;
  clientName: string;
  templateType: string;
  templateCategory?: string;
  publishStatus: string;
  version: number;
}

export async function getLayout(templateId: string): Promise<GetLayoutResult | { message: string }> {
  const key = await keyPromise;
  const EncParams = await AesEncrypt(key, templateId);
  const response = await api.fetch('api/FormDesigner/get_layout', {
    method: 'POST',
    body: JSON.stringify({ EncParams }),
  }).then((r) => r.json());
  return AesDecrypt(key, response);
}

export interface PublishArgs {
  templateId: string | null;
  layoutSchema: FormDocument;
  name: string;
  clientId: string | null;
  clientName: string | null;
  templateCategory?: string;
  docxBlob: Blob;
  fieldWithInstruction: Record<string, { Template_field_name?: string; field_name: string; instruction: string }[]>;
  outputSchema: Record<string, string>;
}

export async function publishForm(args: PublishArgs): Promise<{ templateId: string; version: number }> {
  const username = localStorage.UserName;
  const userId = localStorage.id;

  const formData = new FormData();
  if (args.templateId) formData.append('templateId', args.templateId);
  formData.append('fileName', args.name);
  formData.append('username', username);
  formData.append('userId', userId);
  formData.append('clientName', args.clientName || '');
  formData.append('clientId', args.clientId || '');
  formData.append('templateCategory', args.templateCategory || '');
  formData.append('layoutSchema', JSON.stringify(args.layoutSchema));
  formData.append('Field_with_instruction', JSON.stringify(args.fieldWithInstruction || {}));
  formData.append('output_schema', JSON.stringify(args.outputSchema || {}));
  formData.append('file', args.docxBlob, `${args.name || 'template'}.docx`);

  const token = localStorage.getItem('token');
  const response = await axios.post(webservice + 'api/FormDesigner/publish', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  });

  const key = await keyPromise;
  return AesDecrypt(key, response.data);
}

export interface UploadTemplateResult {
  layoutSchema: FormDocument;
  warnings: string[];
}

// Parses an uploaded PDF/DOCX into a best-effort layoutSchema server-side.
// Stateless on the backend (nothing is saved) — the caller is expected to
// dispatch hydrate(result.layoutSchema) and let the user save normally
// afterward through the existing draft/publish flow.
export async function uploadTemplate(file: File): Promise<UploadTemplateResult> {
  const formData = new FormData();
  formData.append('file', file, file.name);

  const token = localStorage.getItem('token');
  const response = await axios.post(webservice + 'api/FormDesigner/upload_template', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  });

  const key = await keyPromise;
  return AesDecrypt(key, response.data);
}
